<template>
  <div class="header_wrap">
    <div class="top_bar">
      <div class="top_bar_left">
        <img src="@/assets/icon_top_logo.png">
        <!-- <span>ctrlcyte</span> -->
      </div>
      <div class="top_bar_center">
        <div class="nav_list">
          <div class="nav_item_out" v-for="(item, index) in navList" :key="index" @click="goNav(index, item.path)">
            <div class="nav_item">
              <span :class="currentIndex == index ? 'color_orage' : 'color_dark_green'">{{ item.name }}</span>
              <img src="@/assets/icon_down.png" v-if="index != 0">
            </div>
            <div :class="currentIndex == index ? 'line' : 'line_white'"></div>
          </div>
        </div>
      </div>
      <div class="top_bar_right">
        <img src="@/assets/icon_search.png" class="search" @click="openSearch">
        <div class="shop_car" @click="goCenter('/shopcart')">
          <img src="@/assets/icon_shop_car.png">
          <span>{{user.cart_num}}</span>
        </div>
        <img src="@/assets/icon_user.png" class="user" @click="goCenter('/personcenter')" v-if="is_login">
        <div class="login_btn" @click="goCenter('/register')" v-else>登录</div>
      </div>
    </div>

    <el-drawer :visible.sync="drawer"  :modal="false" :direction="direction" :before-close="handleClose" size="100%"
      :modal-append-to-body="true" :append-to-body="true">
      <div style="background:#f1f1f1;height:1px;"></div>
      <div class="search_body">
        <div class="search_input_out">
          <div class="search_input">
            <img src="@/assets/icon_search_blakc.png" @click="goSearch('/search')">
            <input v-model="keyword" @keydown.enter="goSearch('/search')" placeholder="输入内容进行搜索">
          </div>
          <img src="@/assets/icon_close_black.png" class="search_input_out_img" @click="handleClose">
        </div>
        <div class="search-tag">探索产品，咨询采购，资料下载，你需要的都在这里</div>
        <div class="down_li">
          <span class="down_li_item" @click="goSearch2('/search?tab=2')">>资料下载</span>
          <span class="down_li_item" @click="goConsultationview('/consultationview')">>技术咨询</span>
          <span class="down_li_item" @click="goSearch2('/search?tab=1')">>意向采购</span>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: "Header",
  data() {
    return {
      navList: [
        // { name: "首页", path: "/" },
        { name: "商城", path: "/shop" }
      ],
      currentIndex: 0,
      isLogin: true,
      currentPath: window.location.pathname,
      drawer: false,
      direction: "ttb",
      keyword: ''
    };
  },
  computed: {
    ...mapGetters(['base', 'is_login','user'])
  },
  watch: {
    base: {
      handler(newVal) {
        if (newVal.category && newVal.category.length > 0) {
          this.navList = [
            // { name: "首页", path: "/" },

            // ...newVal.category.map(item => ({
            //   name: item.title,
            //   path: `/cellsline/${item.id}`
            // }))
          ]
         
          this.navList.push({ name: "商城", path: "/shop" })
        }
      },
      immediate: true
    },
    "$route":{
      handler(newVal){
        // console.log('当前路由',this.navList.findIndex(item => item.path === newVal.path));
        this.currentIndex = this.navList.findIndex(item => item.path === newVal.path);
      },
      immediate:true
    }
  },
  mounted() { },
  created() {

  },
  methods: {


    handleClose() {
      this.drawer = false;
    },
    goNav(index, path) {
      this.currentIndex = index;
      this.$router.push({ path: path }, () => { }, () => { });
    },
    goCenter(path) {
      this.$router.push({ path: path }, () => { }, () => { });
    },
    openSearch(){
      this.drawer = !this.drawer;
    },
    goSearch(path) {
      this.drawer = false;
      this.$router.push({ path: path, query: { keyword: this.keyword } }, () => { }, () => { });
    },
    goSearch2(path,tab) {
      this.drawer = false;
      this.$router.push({ path: path}, () => { }, () => { });
    },
    goConsultationview(path){
      this.drawer = false;
      this.$router.push({ path: path}, () => { }, () => { });
    },


    handleCommand(command) {
      switch (command) {
        case "1":
          this.$router.replace({ path: "/login1" });
          console.log("aaa", command);
          break;
        case "2":
          this.$router.replace({ path: "/login2" });
          console.log("aaa", command);
          break;
        case "3":
          this.$router.replace({ path: "/login3" });
          console.log("aaa", command);
          break;
      }
    }
  }
};
</script>
<style scoped>


.top_bar {
  height: 90px;
  background-color: #ffffff;
  position: fixed;
  width: 100%;
  z-index: 1001;
  /* 确保它在其他元素之上 */
  display: flex;
  flex-direction: row;
  padding-left: 10%;
  padding-right: 10%;
  box-sizing: border-box;
}

.top_bar_left {
  height: 90px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.top_bar_left img {
  width: 179px;
  height: 40px;
}

.top_bar_center {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-left: 40px;
  flex: 1;
}

.nav_list {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.nav_item {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 88px;
  font-size: 16px;
}

.nav_item img {
  width: 14px;
  height: 14px;
  margin-left: 5px;
}

.nav_item_out {
  margin-left: 10px;
  margin-right: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.line {
  width: 30px;
  height: 2px;
  background: #e69f3e;
  border-radius: 10px;
}

.line_white {
  width: 30px;
  height: 2px;
  background: #ffffff;
  border-radius: 10px;
}

.color_orage {
  color: #e69f3e;
}

.color_dark_green {
  color: #3c9c8f;
}

.top_bar_right {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.search {
  cursor: pointer;
  width: 20px;
  height: 20px;
}

.shop_car {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-left: 10px;
  margin-right: 10px;
}

.shop_car img {
  width: 20px;
  height: 20px;
}

.shop_car span {
  background: #e69f3e;
  font-size: 9px;
  width: 12px;
  height: 12px;
  border-radius: 100px;
  color: white;
  text-align: center;
  line-height: 10px;
  margin-top: -3px;
}

.user {
  width: 20px;
  height: 20px;
  margin-left: 30px;
  cursor: pointer;
}

.login_btn {
  font-size: 16px;
  color: #333333;
  margin-left: 30px;
  cursor: pointer;
}

.search_body {
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  padding-left: 30%;
  padding-right: 30%;
  padding-top: 20px;
  width: 100%;
  background-color: #ffffff;
}

.search_input_out {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex: 1;
  width: 100%;
}

.search_input_out_img {
  cursor: pointer;
  width: 28px;
  height: 28px;
  margin-bottom: 20px;
  margin-left: 100px;
}

.search_input {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding-bottom: 5px;
  width: 100%;
  border-bottom: 1px solid #666666;
}

.search_input img {
  width: 28px;
  height: 28px;
}

.search_input input {
  border: none;
  background: none;
  width: 90%;
  color: #333333;
  font-size: 16px;
  outline: none;

  margin-left: 10px;
}

.search_input input :hover {
  border: none;
  background: none;
  width: 90%;
  color: #999999;
  font-size: 16px;
  outline: none;
}

.search-tag {
  color: #333333;
  font-size: 24px;
  margin-top: 30px;
  margin-bottom: 10px;
}

.down_li {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  color: #333333;
}

.down_li_item {
  margin-bottom: 10px;
  cursor: pointer;
}

</style>

<style>
.el-drawer{
  background-color: transparent!important;
  /* 添加背景模糊效果 */
  backdrop-filter: blur(5px); /* 模糊半径，可以调整数值 */
  /* 为了兼容性，可以加上 -webkit- 前缀 */
  -webkit-backdrop-filter: blur(5px);
  box-shadow: none!important;
}
.el-drawer__wrapper {
  position: fixed;
  top: 15px !important;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  margin: 0;
  z-index:1000!important;
}
</style>
